import Header from 'pages/components/Header'
import React, { useEffect, useState } from 'react'
import styles from './Contact.module.scss'
import Footer from 'pages/components/Footer'
import IconArrowRed from 'static/images/arrow-red.svg'
import BackgroundImg from 'static/images/sub-img-1.png'
import { useRef } from 'react'
import axios from 'axios'
import { notification } from 'antd'
import { useNavigate } from 'react-router-dom'

const Contact = () => {
  const [isLoaded, setIsLoaded] = useState(false)
  const formRef = useRef(null)
  const [agreed, setAgreed] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoaded) {
      // eslint-disable-next-line no-undef
      new daum.roughmap.Lander({
        timestamp: '1649610704648',
        key: '29sb6',
        mapWidth: '1104',
        mapHeight: '400',
      }).render()
      setIsLoaded(true)
    }
  }, [])

  const getFormData = () => {
    const form = formRef.current
    if (!form) return null

    const formElements = form.elements
    const { company, email, tel, content } = formElements

    return {
      company: company.value.trim(),
      email: email.value.trim(),
      tel: tel.value.trim(),
      content: content.value.trim()
    }
  }

  const validateForm = (formData) => {
    if (!formData.company || !formData.email || !formData.tel || !formData.content) {
      notification.warn({
        message: '입력되지 않은 항목이 있습니다',
        placement: 'bottom',
        duration: 2,
      })
      return false
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(formData.email)) {
      notification.warn({
        message: '올바른 이메일 형식을 입력해주세요',
        placement: 'bottom',
        duration: 2,
      })
      return false
    }

    if (!agreed) {
      notification.warn({
        message: '개인정보 수집에 이용동의 해주셔야 전송이 가능합니다.',
        placement: 'bottom',
        duration: 2,
      })
      return false
    }

    return true
  }

  const generateMailtoLink = (formData) => {
    const subject = encodeURIComponent(`[플랜이슈 문의] ${formData.company} - 프로젝트 문의`)
    const body = encodeURIComponent(
      `안녕하세요. ${formData.company}에서 연락드립니다.\n\n` +
      `■ 회사/단체명: ${formData.company}\n` +
      `■ 담당자 이메일: ${formData.email}\n` +
      `■ 연락처: ${formData.tel}\n\n` +
      `■ 문의 내용:\n${formData.content}\n\n` +
      `감사합니다.\n\n` +
      `※ 이 메일은 플랜이슈 홈페이지(https://planissue.com)를 통해 발송되었습니다.`
    )

    return `mailto:samsara12@hanmail.net?subject=${subject}&body=${body}`
  }

  const sendViaMailto = (e) => {
    e.preventDefault()
    
    const formData = getFormData()
    if (!formData || !validateForm(formData)) {
      return
    }

    try {
      const mailtoLink = generateMailtoLink(formData)
      window.location.href = mailtoLink
      
      notification.success({
        message: '이메일 클라이언트가 실행됩니다',
        description: '기본 이메일 프로그램에서 메일을 확인하고 전송해주세요.',
        placement: 'bottom',
        duration: 3,
      })
    } catch (error) {
      notification.error({
        message: '이메일 클라이언트 실행 오류',
        description: '기본 이메일 프로그램 설정을 확인해주세요.',
        placement: 'bottom',
        duration: 3,
      })
    }
  }

  const send = (e) => {
    e.preventDefault()
    
    const formData = getFormData()
    if (!formData || !validateForm(formData)) {
      return
    }

    const form = formRef.current
    if (!form) return

    const formDataObj = new FormData()
    formDataObj.append('file', form.elements.file?.files?.[0] || '')
    formDataObj.append('company', formData.company)
    formDataObj.append('email', formData.email)
    formDataObj.append('tel', formData.tel)
    formDataObj.append('content', formData.content)

    if (confirm('작성하신 내용으로 전송하시겠습니까?')) {
      axios
        .post('/api/contact', formDataObj, {
          headers: { 'content-type': 'multipart/form-data' },
        })
        .then((res) => {
          notification.success({
            message: '전송되었습니다',
            description: '문의해 주셔서 감사합니다. 빠른 시일 내에 답변드리겠습니다.',
            placement: 'bottom',
            duration: 3,
          })
          form.reset()
          setAgreed(false)
        })
        .catch((e) => {
          notification.error({
            message: '전송 실패',
            description: e.response?.data || e.message || '네트워크 오류가 발생했습니다.',
            placement: 'bottom',
            duration: 3,
          })
        })
    }
  }

  return (
    <>
      <article className={styles['contact']}>
        <Header
          title={'CONTACT'}
          discription={'문의 및 회사 위치 안내'}
          backgroundImg={BackgroundImg}
        />
        <section className={styles['content']}>
          <div className={styles['container']}>
            <div className={styles['left']}>
              <h1>
                플랜이슈와 함께
                <br />
                성공적인 프로젝트를
                <br />
                만드세요.
              </h1>
              <img src={IconArrowRed} alt="화살표" />
            </div>
            <div className={styles['right']}>
              <form ref={formRef}>
                <label>
                  <h2>단체 or 회사명</h2>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    maxLength={100}
                    placeholder="회사명을 입력해주세요"
                  />
                </label>
                <label>
                  <h2>이메일</h2>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    maxLength={100}
                    placeholder="담당자 이메일을 입력해주세요"
                  />
                </label>
                <label>
                  <h2>연락처</h2>
                  <input 
                    type="tel" 
                    id="tel" 
                    name="tel" 
                    maxLength={20}
                    placeholder="연락처를 입력해주세요"
                  />
                </label>
                <label>
                  <h2>의뢰/문의 내용</h2>
                  <textarea
                    id="content"
                    name="content"
                    maxLength={10000}
                    placeholder="문의 내용을 자세히 작성해주세요"
                    rows={6}
                  />
                </label>
                {/* <label>
                  <h2>파일첨부</h2>
                  <input type="file" id="file" name="file" />
                </label> */}
                <div className={styles['input-buttom']}>
                  <div>
                    <label className={styles['personal-information-check']}>
                      <input
                        type="checkbox"
                        id="agree"
                        name="agree"
                        checked={agreed}
                        onChange={(e) => setAgreed(e.target.checked)}
                      />
                      <span className={styles['checkmark']}></span>
                      개인정보 수집·이용 동의
                    </label>
                  </div>
                  <div className={styles['button-group']}>
                    <div className={`${styles['button']} ${styles['button-mailto']}`} onClick={sendViaMailto}>
                      이메일로 보내기
                    </div>
                    <div className={styles['button']} onClick={send}>
                      웹사이트로 전송
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
        <section className={`${styles['content']} ${styles['location']}`}>
          <div className={styles['container']}>
            <div className={styles['left']}>
              <h1>
                플랜이슈
                <br />
                찾아 오시는 길
              </h1>
              <img src={IconArrowRed} />
            </div>
            <div className={styles['right']}>
              <h2>Address</h2>
              <h3>서울시 마포구 동교로 23길 32-18 2층 ㈜플랜이슈</h3>
              <h2>Tel</h2>
              <h3>02 337 7983</h3>
              <h2>Fax</h2>
              <h3>02 337 7986</h3>
              <h2>Email</h2>
              <h3>samsara12@hanmail.net</h3>
            </div>
          </div>
          <div className={styles['map']}>
            <div
              id="daumRoughmapContainer1649610704648"
              className="root_daum_roughmap root_daum_roughmap_landing"
            ></div>
          </div>
        </section>
      </article>
      <Footer />
    </>
  )
}

export default Contact
